import { render, staticRenderFns } from "./DepositAccountForm.vue?vue&type=template&id=19a0f7ad&"
import script from "./DepositAccountForm.vue?vue&type=script&lang=ts&"
export * from "./DepositAccountForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports